<form [formGroup]="reiskostenZorgGezinslid">
        <div formArrayName="pgaReiskostenZorgGezinslid">
            <div *ngFor="let item of pgaReiskostenZorgGezinslid.controls; let i = index; "
                          [formGroupName]="i" class="row">

                    <snelstart-ui-text-form-control formControlName="omschrijving"
                                                    id="omschrijving"
                                                    [label]="i === 0 ? 'Omschrijving' : ''"
                                                    class="col-auto custom-input-250"
                                                    (change)="saveForm()"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-number-form-control formControlName="aantalBezoeken"
                                                      id="aantalBezoeken"
                                                      [label]="i === 0 ? 'Aantal bezoeken' : ''"
                                                      class="col-auto custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      (change)="saveForm()"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="afstandRetour"
                                                      id="afstandRetour"
                                                      [label]="i === 0 ? 'Afstand retour in km' : ''"
                                                      class="col-auto custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      (change)="saveForm()"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="werkelijkeKostenOV"
                                                      id="werkelijkeKostenOV"
                                                      [label]="i === 0 ? 'Kosten OV' : ''"
                                                      class="col-auto custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      (change)="saveForm()"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button id="buttonDeleteKosten"
                                                type="secondary"
                                                size="medium"
                                                iconType="light"
                                         icon="trash"
                                                (click)="verwijderRijReiskostenZorgGezinslid(i)"
                                                [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                    >
                    </snelstart-ui-button>
                </div>
            </div>
</form>

<div *ngIf="pgaReiskostenZorgGezinslid.length === 0">
    <snelstart-ui-button class="snelstart-ui-button pb-3" type="link" icon="plus"
                         (click)="addRijReiskostenZorgGezinslid()">Reiskosten bezoek ziek gezinslid
    </snelstart-ui-button>
</div>
<div *ngIf="pgaReiskostenZorgGezinslid.length > 0">
    <snelstart-ui-button class="snelstart-ui-button pb-3" type="link" icon="plus"
                         (click)="addRijReiskostenZorgGezinslid()">Reiskosten bezoek ziek gezinslid toevoegen
    </snelstart-ui-button>
</div>



